import { IdentifiedSymptom } from '@repo/types/src/identified-symptom';
import { IdentifiedSymptomCard } from './IdentifiedSymptomCard';

type IdentifiedSymptomListProps = {
  items: IdentifiedSymptom[];
  refetch: () => void;
};

export const IdentifiedSymptomList = ({
  items,
  refetch,
}: IdentifiedSymptomListProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {items.map((item) => (
        <IdentifiedSymptomCard key={item.id} item={item} refetch={refetch} />
      ))}
    </div>
  );
};
